const mockProcessResult = (initialValue = {}, success = true) => {
  return {
    processResult: {
      status: success ? 's' : 'f',
      code: success ? '00000000' : 'ERR_000_000',
      message: null,
      errorId: null,
      ...initialValue,
    },
  };
};

const mockResponse = (initialValue = {}, success = true, processResult = {}) => {
  if (processResult === null) {
    const { processResult, ...rest } = initialValue;
    return rest;
  }

  return {
    ...initialValue,
    ...mockProcessResult(processResult, success),
  };
};

export { mockProcessResult, mockResponse };
